import React from 'react';
import './Container.scss';
import { classNames } from 'react-extras';

type SizeEnum = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'full';

const Container = ({
    children,
    size,
    className,
    ...props
}: {
    children: React.ReactNode;
    size?: SizeEnum;
    className?: string;
}) => {
    const containerClasses = classNames('Container', {
        [`Container--${size}`]: size,
    });

    return (
        <div className={`${containerClasses} ${className || ''}`} {...props}>
            {children}
        </div>
    );
};

export { Container };
